// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"79a1e1d6","239":"4fd9a07f","455":"e84954a3"}[chunkId] + ".chunk.js";
};